import React from "react";
import Modal from "react-bootstrap/Modal";
//UI
import {
  Checkbox,
  Input,
  Radio,
  SearchInput,
  Select,
  Textarea,
} from "../../../../ui/inputs/Input";
import { DangerButton, SuccessButton } from "../../../../ui/buttons/Button";

export default function Usuarios({ show, setShow, setTabla }) {
  const salir = () => {
    setShow(false);
    setTabla(0);
  };

  return (
    <Modal size="lg" show={show} centered backdrop="static" keyboard={false}>
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
        <h3 className="fw-bold m-0">Usuario Administración y Tesoreria</h3>
        <a type="button" className="fw-bold text-light fs-6" onClick={salir}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <nav>
          <div className="nav nav-tabs mb-2" id="nav-tab" role="tablist">
            <button
              className="nav-link active"
              id="nav-usuario-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-usuario"
              type="button"
              role="tab"
              aria-controls="nav-usuario"
              aria-selected="true"
            >
              Usuarios
            </button>
            <button
              className="nav-link"
              id="nav-permisos-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-permisos"
              type="button"
              role="tab"
              aria-controls="nav-permisos"
              aria-selected="false"
            >
              Permisos Aplicación Nomina
            </button>
          </div>
        </nav>
        <div className="tab-content" id="nav-tabContent">
          <div
            className="tab-pane fade show active"
            id="nav-usuario"
            role="tabpanel"
            aria-labelledby="nav-usuario-tab"
            tabindex="0"
          >
            <div className="col-12 m-0 p-0 d-flex flex-wrap">
              <div className="col-3 m-0 mb-2 p-0">
                <Input label="Código:" />
              </div>
              <div className="col-6 m-0 mb-2 pl-2">
                <Input label="Nombre de Usuario:" />
              </div>
              <div className="col-12 m-0 p-0 d-flex gap-2">
                <Input label="Contraseña:" />
                <Input label="Confirmar Contraseña:" />
              </div>
              <fieldset className="col-12 m-0 p-2 d-flex gap-2 border-azul rounded">
                <legend className="w-auto float-none m-0">Organización</legend>
                <div className="col-3 m-0 p-0">
                  <SearchInput label="Código:" />
                </div>
                <Input label="Descripción:" />
              </fieldset>
              <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
                <legend className="w-auto float-none m-0">
                  Datos Personales Des Usuario
                </legend>
                <div className="col-12 m-0 mb-2 p-0">
                  <div className="col-3 m-0 p-0">
                    <SearchInput label="Cédula:" />
                  </div>
                </div>
                <div className="col-6 m-0 mb-2 p-0">
                  <Input label="Nombres:" />
                </div>
                <div className="col-6 m-0 mb-2 p-0 pl-2">
                  <Input label="Apellidos:" />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Textarea label="Dirección:" style={{ height: 70 }} />
                </div>
                <div className="col-5 m-0 mb-2 p-0">
                  <Input label="Correo Electrónico:" />
                </div>
                <div className="col-4 m-0 mb-2 p-0 pl-2">
                  <Input label="Teléfono:" />
                </div>
                <div className="col-3 m-0 mb-2 p-0 pl-2">
                  <Input label="Celular:" />
                </div>
                <div className="col-4 m-0 p-0">
                  <Input label="Fecha de Nacimiento:" type="date" />
                </div>
                <div className="col-3 m-0 p-0 pl-2">
                  <Select label="Nacionalidad:"></Select>
                </div>
                <div className="col-2 m-0 p-0 pl-2">
                  <Select label="Sexo:"></Select>
                </div>
              </fieldset>
            </div>
          </div>
          <div
            className="tab-pane fade"
            id="nav-permisos"
            role="tabpanel"
            aria-labelledby="nav-permisos-tab"
            tabindex="0"
          >
            <nav>
              <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <button
                  class="nav-link active"
                  id="nav-opciones-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-opciones"
                  type="button"
                  role="tab"
                  aria-controls="nav-opciones"
                  aria-selected="true"
                >
                  Opciones
                </button>
                <button
                  class="nav-link"
                  id="nav-archivos-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-archivos"
                  type="button"
                  role="tab"
                  aria-controls="nav-archivos"
                  aria-selected="false"
                >
                  Archivos
                </button>
                <button
                  class="nav-link"
                  id="nav-transacciones-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-transacciones"
                  type="button"
                  role="tab"
                  aria-controls="nav-transacciones"
                  aria-selected="false"
                >
                  Transacciones
                </button>
                <button
                  class="nav-link"
                  id="nav-reportes-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-reportes"
                  type="button"
                  role="tab"
                  aria-controls="nav-reportes"
                  aria-selected="false"
                >
                  Reportes
                </button>
                <button
                  class="nav-link"
                  id="nav-varios-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-varios"
                  type="button"
                  role="tab"
                  aria-controls="nav-varios"
                  aria-selected="false"
                >
                  Varios
                </button>
                <button
                  class="nav-link"
                  id="nav-configuracion-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-configuracion"
                  type="button"
                  role="tab"
                  aria-controls="nav-configuracion"
                  aria-selected="false"
                >
                  Configuración
                </button>
              </div>
            </nav>
            <div class="tab-content" id="nav-tabContent">
              <div
                class="tab-pane fade show active"
                id="nav-opciones"
                role="tabpanel"
                aria-labelledby="nav-opciones-tab"
                tabindex="0"
              >
                <fieldset className="col-4 m-0 mb-2 p-2 d-flex gap-2 border-azul rounded">
                  <legend className="w-auto float-none m-0">
                    Seleccionar Nomina
                  </legend>
                  <div className="col-auto m-0 p-0">
                    <Radio
                      label="Disponible"
                      name="disponible"
                      id="disponible1"
                    />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Radio
                      label="No Disponible"
                      name="disponible"
                      id="disponible2"
                    />
                  </div>
                </fieldset>
                <fieldset className="col-6 m-0 p-2 d-flex gap-2 border-azul rounded">
                  <legend className="w-auto float-none m-0">
                    Tipos de Nomina/Otros Pagos
                  </legend>
                  <div className="col-auto m-0 p-0">
                    <Checkbox label="Consultar" id="consultar_nomina" />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Checkbox label="Incluir" id="incluir_nomina" />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Checkbox label="Editar" id="editar_nomina" />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Checkbox label="Eliminar" id="eliminar_nomina" />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Checkbox label="Todas" id="todas_nomina" />
                  </div>
                </fieldset>
              </div>
              <div
                class="tab-pane fade"
                id="nav-archivos"
                role="tabpanel"
                aria-labelledby="nav-archivos-tab"
                tabindex="0"
              >
                <div className="col-12 m-0 p-0 d-flex flex-wrap">
                  <div className="col-12 m-0 p-0">
                    <fieldset className="col-4 m-0 mb-2 p-2 d-flex gap-2 border-azul rounded">
                      <legend className="w-auto float-none m-0">
                        Configurar Nomina
                      </legend>
                      <div className="col-auto m-0 p-0">
                        <Radio
                          label="Disponible"
                          name="disponible"
                          id="disponible1"
                        />
                      </div>
                      <div className="col-auto m-0 p-0">
                        <Radio
                          label="No Disponible"
                          name="disponible"
                          id="disponible2"
                        />
                      </div>
                    </fieldset>
                  </div>
                  <fieldset className="col-6 m-0 p-2 d-flex gap-2 border-azul rounded">
                    <legend className="w-auto float-none m-0">
                      Constantes
                    </legend>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Consultar" id="consultar_nomina" />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Incluir" id="incluir_nomina" />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Editar" id="editar_nomina" />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Eliminar" id="eliminar_nomina" />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Todas" id="todas_nomina" />
                    </div>
                  </fieldset>
                  <fieldset className="col-6 m-0 p-2 d-flex gap-2 border-azul rounded">
                    <legend className="w-auto float-none m-0">Conceptos</legend>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Consultar" id="consultar_nomina" />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Incluir" id="incluir_nomina" />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Editar" id="editar_nomina" />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Eliminar" id="eliminar_nomina" />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Todas" id="todas_nomina" />
                    </div>
                  </fieldset>
                  <fieldset className="col-6 m-0 p-2 d-flex gap-2 border-azul rounded">
                    <legend className="w-auto float-none m-0">
                      Grupo de Nominas
                    </legend>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Consultar" id="consultar_grupoNomina" />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Incluir" id="incluir_grupoNomina" />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Editar" id="editar_grupoNomina" />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Eliminar" id="eliminar_grupoNomina" />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Todas" id="todas_grupoNomina" />
                    </div>
                  </fieldset>
                </div>
              </div>
              <div
                class="tab-pane fade"
                id="nav-transacciones"
                role="tabpanel"
                aria-labelledby="nav-transacciones-tab"
                tabindex="0"
              >
                <div className="col-12 m-0 p-0 d-flex flex-wrap">
                  <fieldset className="col-6 m-0 p-2 d-flex gap-2 border-azul rounded">
                    <legend className="w-auto float-none m-0">
                      Procesar Nomina
                    </legend>
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="Disponible"
                        name="precesar_disponible"
                        id="procesar_disponible1"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="No Disponible"
                        name="precesar_disponible"
                        id="procesar_disponible2"
                      />
                    </div>
                  </fieldset>
                  <fieldset className="col-6 m-0 p-2 d-flex gap-2 border-azul rounded">
                    <legend className="w-auto float-none m-0">
                      Revisar Nomina
                    </legend>
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="Disponible"
                        name="revisar_disponible"
                        id="revisar_disponible1"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="No Disponible"
                        name="revisar_disponible"
                        id="revisar_disponible2"
                      />
                    </div>
                  </fieldset>
                  <fieldset className="col-6 m-0 p-2 d-flex gap-2 border-azul rounded">
                    <legend className="w-auto float-none m-0">
                      Vacaciones
                    </legend>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Consultar" id="consultar_vacaciones" />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Incluir" id="incluir_vacaciones" />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Editar" id="editar_vacaciones" />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Eliminar" id="eliminar_vacaciones" />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Todas" id="todas_vacaciones" />
                    </div>
                  </fieldset>
                  <fieldset className="col-6 m-0 p-2 d-flex gap-2 border-azul rounded">
                    <legend className="w-auto float-none m-0">
                      Adelanto Vacaciones
                    </legend>
                    <div className="col-auto m-0 p-0">
                      <Checkbox
                        label="Consultar"
                        id="consultar_adelantoVacaciones"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox
                        label="Incluir"
                        id="incluir_adelantoVacaciones"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Editar" id="editar_adelantoVacaciones" />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox
                        label="Eliminar"
                        id="eliminar_adelantoVacaciones"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Todas" id="todas_adelantoVacaciones" />
                    </div>
                  </fieldset>
                  <fieldset className="col-6 m-0 p-2 d-flex gap-2 border-azul rounded">
                    <legend className="w-auto float-none m-0">
                      Liquidación
                    </legend>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Consultar" id="consultar_liquidacion" />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Incluir" id="incluir_liquidacion" />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Editar" id="editar_liquidacion" />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Eliminar" id="eliminar_liquidacion" />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Todas" id="todas_liquidacion" />
                    </div>
                  </fieldset>
                  <fieldset className="col-6 m-0 p-2 d-flex gap-2 border-azul rounded">
                    <legend className="w-auto float-none m-0">
                      Prestaciones Antiguao Regimen
                    </legend>
                    <div className="col-auto m-0 p-0">
                      <Checkbox
                        label="Consultar"
                        id="consultar_prestacionesAntReg"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox
                        label="Incluir"
                        id="incluir_prestacionesAntReg"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Editar" id="editar_prestacionesAntReg" />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox
                        label="Eliminar"
                        id="eliminar_prestacionesAntReg"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Todas" id="todas_prestacionesAntReg" />
                    </div>
                  </fieldset>
                  <fieldset className="col-6 m-0 mr-2 p-2 d-flex gap-2 border-azul rounded">
                    <legend className="w-auto float-none m-0">
                      Liquidación
                    </legend>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Consultar" id="consultar_liquidacion" />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Incluir" id="incluir_liquidacion" />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Editar" id="editar_liquidacion" />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Eliminar" id="eliminar_liquidacion" />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Todas" id="todas_liquidacion" />
                    </div>
                  </fieldset>
                  <fieldset className="col-6 m-0 p-2 d-flex gap-2 border-azul rounded">
                    <legend className="w-auto float-none m-0">
                      Adelanto Prestaciones
                    </legend>
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="Disponible"
                        name="adelantoPrestaciones_disponible"
                        id="adelantoPrestaciones_disponible1"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="No Disponible"
                        name="adelantoPrestaciones_disponible"
                        id="adelantoPrestaciones_disponible2"
                      />
                    </div>
                  </fieldset>
                  <fieldset className="col-6 m-0 p-2 d-flex gap-2 border-azul rounded">
                    <legend className="w-auto float-none m-0">
                      Grabar Acumulados
                    </legend>
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="Disponible"
                        name="grabarAcumulados_disponible"
                        id="grabarAcumulados_disponible1"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="No Disponible"
                        name="grabarAcumulados_disponible"
                        id="grabarAcumulados_disponible2"
                      />
                    </div>
                  </fieldset>
                  <fieldset className="col-6 m-0 p-2 d-flex gap-2 border-azul rounded">
                    <legend className="w-auto float-none m-0">
                      Generar Períodos
                    </legend>
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="Disponible"
                        name="generarPeriodos_disponible"
                        id="generarPeriodos_disponible1"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="No Disponible"
                        name="generarPeriodos_disponible"
                        id="generarPeriodos_disponible2"
                      />
                    </div>
                  </fieldset>
                  <fieldset className="col-6 m-0 p-2 d-flex gap-2 border-azul rounded">
                    <legend className="w-auto float-none m-0">
                      Prestaciones
                    </legend>
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="Disponible"
                        name="prestaciones_disponible"
                        id="prestaciones_disponible1"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="No Disponible"
                        name="prestaciones_disponible"
                        id="prestaciones_disponible2"
                      />
                    </div>
                  </fieldset>
                  <fieldset className="col-6 m-0 mr-2 p-2 d-flex gap-2 border-azul rounded">
                    <legend className="w-auto float-none m-0">
                      Otros Prestamos
                    </legend>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Consultar" id="consultar_otrosPrestamos" />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Incluir" id="incluir_otrosPrestamos" />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Editar" id="editar_otrosPrestamos" />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Eliminar" id="eliminar_otrosPrestamos" />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Todas" id="todas_otrosPrestamos" />
                    </div>
                  </fieldset>
                  <fieldset className="col-6 m-0 p-2 d-flex gap-2 border-azul rounded">
                    <legend className="w-auto float-none m-0">
                      Crear Diskette
                    </legend>
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="Disponible"
                        name="crearDiskette_disponible"
                        id="crearDiskette_disponible1"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="No Disponible"
                        name="crearDiskette_disponible"
                        id="crearDiskette_disponible2"
                      />
                    </div>
                  </fieldset>
                </div>
              </div>
              <div
                class="tab-pane fade"
                id="nav-reportes"
                role="tabpanel"
                aria-labelledby="nav-reportes-tab"
                tabindex="0"
              >
               ...
              </div>
              <div
                class="tab-pane fade"
                id="nav-varios"
                role="tabpanel"
                aria-labelledby="nav-varios-tab"
                tabindex="0"
              >
                <div className="col-12 m-0 p-0 d-flex flex-wrap">
                  <fieldset className="col-6 m-0 p-2 d-flex gap-2 border-azul rounded">
                    <legend className="w-auto float-none m-0">
                      Fecha y Num. Período Mes
                    </legend>
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="Disponible"
                        name="fechaNumPeriodoMes_disponible"
                        id="fechaNumPeriodoMes_disponible1"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="No Disponible"
                        name="fechaNumPeriodoMes_disponible"
                        id="fechaNumPeriodoMes_disponible2"
                      />
                    </div>
                  </fieldset>
                  <fieldset className="col-6 m-0 p-2 d-flex gap-2 border-azul rounded">
                    <legend className="w-auto float-none m-0">
                      Copiar Conceptos y Trabajadores
                    </legend>
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="Disponible"
                        name="copiarConceptosTrabajadores_disponible"
                        id="copiarConceptosTrabajadores_disponible1"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="No Disponible"
                        name="copiarConceptosTrabajadores_disponible"
                        id="copiarConceptosTrabajadores_disponible2"
                      />
                    </div>
                  </fieldset>
                  <fieldset className="col-6 m-0 p-2 d-flex gap-2 border-azul rounded">
                    <legend className="w-auto float-none m-0">
                      Usuarios
                    </legend>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Consultar" id="consultar_usuarios" />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Incluir" id="incluir_usuarios" />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Editar" id="editar_usuarios" />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Eliminar" id="eliminar_usuarios" />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Todas" id="todas_usuarios" />
                    </div>
                  </fieldset>
                  <fieldset className="col-6 m-0 p-2 d-flex gap-2 border-azul rounded">
                    <legend className="w-auto float-none m-0">
                      Actualizar Días Feriados
                    </legend>
                    <div className="col-auto m-0 p-0">
                      <Checkbox
                        label="Consultar"
                        id="consultar_actualizarDiasFeriados"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox
                        label="Incluir"
                        id="incluir_actualizarDiasFeriados"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Editar" id="editar_actualizarDiasFeriados" />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox
                        label="Eliminar"
                        id="eliminar_actualizarDiasFeriados"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Todas" id="todas_actualizarDiasFeriados" />
                    </div>
                  </fieldset>
                </div>
              </div>
              <div
                class="tab-pane fade"
                id="nav-configuracion"
                role="tabpanel"
                aria-labelledby="nav-configuracion-tab"
                tabindex="0"
              >
                <div className="col-12 m-0 p-0 d-flex flex-wrap">
                  <fieldset className="col-6 m-0 p-2 d-flex gap-2 border-azul rounded">
                    <legend className="w-auto float-none m-0">
                      Organización
                    </legend>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Consultar" id="consultar_organizacion" />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Incluir" id="incluir_organizacion" />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Editar" id="editar_organizacion" />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Eliminar" id="eliminar_organizacion" />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Todas" id="todas_organizacion" />
                    </div>
                  </fieldset>
                  <fieldset className="col-6 m-0 p-2 d-flex gap-2 border-azul rounded">
                    <legend className="w-auto float-none m-0">
                      Personas
                    </legend>
                    <div className="col-auto m-0 p-0">
                      <Checkbox
                        label="Consultar"
                        id="consultar_personas"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox
                        label="Incluir"
                        id="incluir_personas"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Editar" id="editar_personas" />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox
                        label="Eliminar"
                        id="eliminar_personas"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Todas" id="todas_personas" />
                    </div>
                  </fieldset>
                  <fieldset className="col-6 m-0 mr-2 p-2 d-flex gap-2 border-azul rounded">
                    <legend className="w-auto float-none m-0">
                      Valor Unidad Tributaria
                    </legend>
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="Disponible"
                        name="valorUnidadTributaria_disponible"
                        id="valorUnidadTributaria_disponible1"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="No Disponible"
                        name="valorUnidadTributaria_disponible"
                        id="valorUnidadTributaria_disponible2"
                      />
                    </div>
                  </fieldset>
                  <fieldset className="col-6 m-0 p-2 d-flex gap-2 border-azul rounded">
                    <legend className="w-auto float-none m-0">
                      Tasa Activa
                    </legend>
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="Disponible"
                        name="tasaActiva_disponible"
                        id="tasaActiva_disponible1"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="No Disponible"
                        name="tasaActiva_disponible"
                        id="tasaActiva_disponible2"
                      />
                    </div>
                  </fieldset>
                  <fieldset className="col-6 m-0 p-2 d-flex gap-2 border-azul rounded">
                    <legend className="w-auto float-none m-0">
                      Tasa Pasiva
                    </legend>
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="Disponible"
                        name="tasaPasiva_disponible"
                        id="tasaPasiva_disponible1"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="No Disponible"
                        name="tasaPasiva_disponible"
                        id="tasaPasiva_disponible2"
                      />
                    </div>
                  </fieldset>
                  <fieldset className="col-6 m-0 p-2 d-flex gap-2 border-azul rounded">
                    <legend className="w-auto float-none m-0">
                      Desconextar Usuarios
                    </legend>
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="Disponible"
                        name="desconectarUsuarios_disponible"
                        id="desconectarUsuarios_disponible1"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="No Disponible"
                        name="desconectarUsuarios_disponible"
                        id="desconectarUsuarios_disponible2"
                      />
                    </div>
                  </fieldset>
                  <fieldset className="col-6 m-0 p-2 d-flex gap-2 border-azul rounded">
                    <legend className="w-auto float-none m-0">
                      Desbloquear Registros
                    </legend>
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="Disponible"
                        name="desbloquearRegistros_disponible"
                        id="desbloquearRegistros_disponible1"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="No Disponible"
                        name="desbloquearRegistros_disponible"
                        id="desbloquearRegistros_disponible2"
                      />
                    </div>
                  </fieldset>
                  <fieldset className="col-6 m-0 p-2 d-flex gap-2 border-azul rounded">
                    <legend className="w-auto float-none m-0">
                      Puerto Impresora
                    </legend>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Posee Impresora" id="poseeImpresora" />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="USB"
                        name="puertoImpresora_disponible"
                        id="puertoImpresora_disponible1"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="Paralelo"
                        name="puertoImpresora_disponible"
                        id="puertoImpresora_disponible2"
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="Serial"
                        name="puertoImpresora_disponible"
                        id="puertoImpresora_disponible2"
                      />
                    </div>
                  </fieldset>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton>Aceptar</SuccessButton>
        <DangerButton>Cancelar</DangerButton>
      </Modal.Footer>
    </Modal>
  );
}
